import { openTimePanel, isTimePanelAvailable, popView } from 'owa-time-panel-bootstrap';
import { isPanelOpen, getSelectedCalendarItemId } from '../selectors/timePanelStoreSelectors';
import { orchestrator } from 'satcheljs';
import { openTimePanelInternal } from '../actions/timePanelStoreActions';
import { toggleTimePanel } from '../utils/toggleTimePanel';
import { getCurrentPanelView } from 'owa-time-panel-view-stack';
import { closeNotesEditor } from 'owa-calendar-notes-editor';

export const openTimePanelOrchestrator = orchestrator(openTimePanel, actionMessage => {
    // sanity check for feature availability
    if (!isTimePanelAvailable()) {
        return;
    }

    openTimePanelInternal(actionMessage.source);

    // noop if panel is already open
    if (isPanelOpen()) {
        return;
    }

    toggleTimePanel();
});

export const cleanEventDetailsViewStateOrchestrator = orchestrator(popView, () => {
    if (getCurrentPanelView() == 'EventDetails') {
        closeNotesEditor(getSelectedCalendarItemId());
    }
});
